import { UnitListItemStatusType } from '../stories/UnitListItem';

export interface LessonIndexPageUnit {
  id: number;
  position: number;
  current: boolean;
  name: string;
  status: UnitStatus;
  thumbSrc: string;
  description: string;
  description_es: string;
  'description_pt-BR': string;
}

type UnitStatus = 'in_progress' | 'pending' | 'completed';

export const getLessonIndexPageUnitStatus = (unit: LessonIndexPageUnit): UnitListItemStatusType => {
  switch (unit.status) {
    case 'in_progress':
      return 'current';
    case 'completed':
      return 'done';
    case 'pending':
    default:
      return 'blocked';
  }
};
